export default __webpack_public_path__ + "static/media/8F0DEA8C-10A9-4FCE-B0E9-FE95E51238F3.0a42ad47.jpg";